import * as React from 'react';
import { ApolloQueryResult } from 'apollo-client';
import ActiveGroupsListFetcher from 'groups/containers/GroupList/ActiveGroupsListFetcher';
import UnclaimedGroupsListFetcher from 'groups/containers/GroupList/UnclaimedGroupsListFetcher';

import { GroupRow, GroupStatus } from 'groups/components/GroupList/GroupListTable';
// @ts-ignore
import { SortDirection } from 'components/ComposableTable';
// @ts-ignore
import { Sort as SortType } from 'clients/api/organizationClasses';
import { ActiveGroupsQuery } from 'groups/containers/GroupList/queries/__generated__/ActiveGroupsQuery';
import { UnclaimedGroupsQuery } from 'groups/containers/GroupList/queries/__generated__/UnclaimedGroupsQuery';

export type Props = {
  groupStatus: GroupStatus;
  orgUuid: string;
  query: string | null;
  sortDirection: SortDirection;
  sortType: SortType;
  handleError: () => void;
  children: (
    props: {
      groups?: GroupRow[];
      handleFetchMore?: () => Promise<ApolloQueryResult<ActiveGroupsQuery | UnclaimedGroupsQuery>>;
      loading: boolean;
      hasNextPage: boolean;
      refetch?: () => Promise<ApolloQueryResult<ActiveGroupsQuery | UnclaimedGroupsQuery>>;
    }
  ) => React.ReactNode;
};

export default function GroupsListFetcher(props: Props) {
  if (props.groupStatus === 'unclaimed') {
    return <UnclaimedGroupsListFetcher {...props} />;
  } else {
    return <ActiveGroupsListFetcher {...props} />;
  }
}
